import { ActiveScene } from '../studio/studio.types';

export const MOCK_SCENE: ActiveScene = {
  id: "mock-scene-01",
  ownerId: "user-123",
  data: {
    schema: "1.0.0",
    scene_id: "mock-scene-01",
    active_camera_id: "camera-rig-01",
    units: { length: "m", angle: "deg" },
    coordinate_system: { handedness: "right", up_axis: "y", forward_axis: "z" },
    root: {
      nodes: [
        {
          id: "splat-01",
          type: "object",
          transform: {
            translation: [0, 0, 0],
            rotation: [0, 0, 0, 1],
            scale: [1, 1, 1]
          },
          asset_ref: {
            pid: "truck",
            url: "https://antimatter15.com/splat/truck.splat"
          }
        },
        {
          id: "camera-rig-01",
          type: "camera_rig",
          transform: {
            translation: [0, 2, 5],
            rotation: [0, 0, 0, 1],
            scale: [1, 1, 1]
          },
          rig: {
            mode: "orbit",
            target: "0,0,0",
            radius: 5,
            height: 2,
            azimuth_range: [-180, 180],
            polar_angle: 45
          }
        }
      ]
    }
  }
};